import { cn } from "@/lib/utils";
import { branding } from "@/config/branding";

/** The HibirEVAP mark — a layered shield drawn as concentric chevrons (a "scan sweep"). */
export function LogoMark({ className }: { className?: string }) {
  return (
    <span className={cn("flex size-8 shrink-0 items-center justify-center rounded-[9px] bg-primary text-primary-foreground shadow-sm", className)}>
      <svg viewBox="0 0 24 24" className="size-[18px]" fill="none" aria-hidden>
        <path d="M12 2.5 4 5.5v6c0 4.6 3.2 8.3 8 10 4.8-1.7 8-5.4 8-10v-6L12 2.5Z" fill="currentColor" opacity="0.25" />
        <path d="M12 6.2 7.5 8v3.4c0 2.7 1.9 4.9 4.5 5.9 2.6-1 4.5-3.2 4.5-5.9V8L12 6.2Z" fill="currentColor" />
        <path d="m9.6 11.6 1.8 1.8 3.2-3.4" stroke="var(--primary)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </span>
  );
}

export function Logo({ className, showName = true }: { className?: string; showName?: boolean }) {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <LogoMark />
      {showName && (
        <span className="flex flex-col leading-none">
          <span className="text-[15px] font-bold tracking-tight">{branding.name}</span>
          <span className="mt-0.5 text-[10px] font-medium uppercase tracking-[0.16em] text-muted-foreground">DAST Console</span>
        </span>
      )}
    </div>
  );
}
